<div class="position-relative">
    <div *ngIf="data && data.attributes.BodyRich" class="ck-content" [innerHTML]="this.sanitizer
.bypassSecurityTrustHtml(data.attributes.BodyRich)"></div>
    <div *ngIf="data && data.attributes.Body">
        <markdown ngPreserveWhitespaces [data]="data.attributes.Body"></markdown>
    </div>
</div>